import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=f7f0a8f0&scoped=true&"
import script from "./BasePage.vue?vue&type=script&lang=js&"
export * from "./BasePage.vue?vue&type=script&lang=js&"
import style0 from "./BasePage.vue?vue&type=style&index=0&id=f7f0a8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f0a8f0",
  null
  
)

export default component.exports